import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import './styles.scss';

export default function DealPlannerTable({
  children,
  className,
  hasDates,
  hasTasks,
  selectAllChecked,
  showDealColumn,
  showIndeterminate,
  showSelectColumn,
  onSelectToggle
}) {
  const dateHeaderParts = [];

  if (hasDates) {
    dateHeaderParts.push('Critical Date');
  }

  if (hasTasks || !hasDates) {
    dateHeaderParts.push('Task');
  }

  return (
    <div className="planner-table-container mt-4">
      <table className={classNames('planner-table', className)}>
        <thead>
          <tr className="planner-row">
            {showSelectColumn && (
              <th className="text-center">
                <input
                  aria-label="Select All"
                  checked={selectAllChecked || false}
                  ref={input => input && (input.indeterminate = showIndeterminate)}
                  type="checkbox"
                  onChange={onSelectToggle}
                />
              </th>
            )}
            <th className="task-complete"/>
            <th/>
            <th className="planner-table-date">Date</th>
            { showDealColumn && <th>Deal</th> }
            <th>{dateHeaderParts.join(' / ')}</th>
            <th className="text-center">Attachments</th>
            <th>Assignee</th>
            <th/>
          </tr>
        </thead>
        <tbody>
          {children}
        </tbody>
      </table>
    </div>
  );
}

DealPlannerTable.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  hasDates: PropTypes.bool,
  hasTasks: PropTypes.bool,
  selectAll: PropTypes.func,
  selectAllChecked: PropTypes.bool,
  showDealColumn: PropTypes.bool,
  showIndeterminate: PropTypes.bool,
  showSelectColumn: PropTypes.bool,
  onSelectToggle: PropTypes.func,
};
